import { render, staticRenderFns } from "./rehabOrdersTimeTreatmentLogEditModal.html?vue&type=template&id=c61cdfee&"
import script from "./rehabOrdersTimeTreatmentLogEditModal.vue?vue&type=script&lang=js&"
export * from "./rehabOrdersTimeTreatmentLogEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports